import styled from 'styled-components';

import Badge from 'components/v2/Badge';

export const NotifyBadge = styled(Badge)`
  &&& {
    svg {
      margin-left: 2px;
      font-size: 20px;
    }
  }
`;
